import { useCallback } from 'react';
import { Label } from 'src/components/label';
import useAuth from 'src/auth/useAuth';
import {
  MainWalletPurpose,
  useGetFlaggedDepositsCountQuery,
  useGetTransactionsToApproveCountQuery,
} from 'src/generated/graphql';

export function useApprovalCount() {
  const { organizationId } = useAuth();
  const pause = !organizationId;

  const [{ data: withdrawalsData }, refetchWithdrawals] = useGetTransactionsToApproveCountQuery({
    variables: {
      organizationId: organizationId || '',
      purpose: MainWalletPurpose.Default,
    },
    pause,
    requestPolicy: 'cache-and-network',
  });

  const [{ data: flaggedData }, refetchFlagged] = useGetFlaggedDepositsCountQuery({
    variables: { organizationId: organizationId || '' },
    pause,
    requestPolicy: 'cache-and-network',
  });

  const withdrawals = withdrawalsData?.getTransactionsToApprove.totalCount ?? 0;
  const flagged = flaggedData?.getFlaggedDeposits.totalCount ?? 0;
  const count = withdrawals + flagged;

  const refetch = useCallback(() => {
    void refetchWithdrawals({ requestPolicy: 'network-only' });
    void refetchFlagged({ requestPolicy: 'network-only' });
  }, [refetchWithdrawals, refetchFlagged]);

  return { count, withdrawals, flagged, refetch };
}

export function ApprovalCountBadge({ count }: { count: number }) {
  if (count <= 0) {
    return null;
  }

  return (
    <Label color="error" variant="filled" sx={{ height: 20, minWidth: 20, px: 0.5 }}>
      {count > 99 ? '99+' : count}
    </Label>
  );
}
